export default {
  PRINCIPAL: "校长",
  VICE_PRINCIPAL: "副校长",
  ASSISTANT_PRINCIPAL: "助理校长",
  DISCIPLINE: "辅导及训导主任",
  SCH_AFFR_OFFICER: "课程发展主任/学务主任/教务主任",
  SUBJECT_PANEL: "学科主任",
  SUBJECT_TEACHER: "学科教师",
  IT_COORDINATOR: "资讯科技统筹主任/统筹员",
  LIBRARIAN: "图书馆主任/老师",
  CAREER: "升学及就业主任",
  CDP_COORDINATOR: "持续专业发展统筹主任 / 统筹员",
  OTHERS: "其他",
};
